import type { Place } from "owa-graph-schema";
import { queryWithError } from "hybridspace-graphql/lib/utils/queryWithError";
import { GetSectionsPlacesDocument, type GetSectionsPlacesQuery, } from "hybridspace-graphql/lib/graphql/__generated__/getSectionsPlacesQuery.interface";

export default async function fetchSections(floorId: string, refetch = false): Promise<Place[]> {
    const { data } = await queryWithError(GetSectionsPlacesDocument, {
        variables: {
            query: `ParentId = "${floorId}" AND Type = "Section"`,
        },
        fetchPolicy: refetch ? "network-only" : "cache-first",
    });
    
    return processSectionsData(data, floorId);
}

function processSectionsData(data: GetSectionsPlacesQuery | undefined, floorId: string): Place[] {
    const sections = (data?.sections?.sections ?? []).filter((section): section is NonNullable<typeof section> => !!section);
    
    return sections
        .map(section => ({
        id: section.id,
        name: section.name,
        parentId: section.floorId ?? floorId,
    }) as Place)
        .sort(compareSections);
}

function compareSections(a: Place, b: Place) {
    if (a.name && b.name) {
        return a.name.localeCompare(b.name);
    }
    
    return 0;
}
//     const ownerId = getUserExternalDirectoryId();
